/** @format */

export const AmexSmall = () => {
    return (
        <svg width="23" height="16" viewBox="0 0 23 16" fill="none">
            <rect x="0.5" y="0.5" width="22" height="15" rx="2" fill="#1F72CD" stroke="#D9D9D9" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.1443 5.62039L2 10.576H4.56703L4.88527 9.78589H5.61269L5.93093 10.576H8.75651V9.97297L9.00828 10.576H10.4699L10.7217 9.96023V10.576H16.5981L17.3127 9.80641L17.9817 10.576L21 10.5824L18.8489 8.11204L21 5.62039H18.0285L17.333 6.37578L16.685 5.62039H10.2922L9.74322 6.89948L9.18139 5.62039H6.61972V6.20293L6.33475 5.62039H4.1443ZM12.9196 6.3241H16.2941L17.3262 7.48839L18.3916 6.3241H19.4237L17.8555 8.11135L19.4237 9.878H18.3448L17.3127 8.70018L16.2419 9.878H12.9196V6.3241ZM13.7529 7.70951V7.06037V7.05975H15.8585L16.7773 8.0979L15.8178 9.14172H13.7529V8.43304H15.5939V7.70951H13.7529ZM4.64098 6.3241H5.89227L7.31459 9.68454V6.3241H8.68533L9.7839 8.73352L10.7964 6.3241H12.1603V9.88009H11.3304L11.3236 7.09364L10.1137 9.88009H9.3713L8.15461 7.09364V9.88009H6.44733L6.12366 9.08288H4.37499L4.05199 9.87939H3.13725L4.64098 6.3241ZM4.67359 8.34592L5.2497 6.92576L5.82515 8.34592H4.67359Z"
                fill="white"
            />
        </svg>
    );
};
